export default "__VITE_ASSET__DvUNR4w8__"